import Icon from './Icon';

export { iconSize } from './Icon';
export type { IconSize } from './types';

export default Icon;
